import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IPackagePrice } from '@root/types/package';
import Radio from '../Radio';
import { UNLIMITED_PACKAGE_NUMBER } from '@root/constant';

const PackageCard = ({
  title,
  priceList,
  checkedPriceId,
  description,
  maxDevNum,
  onSelected,
  className = '',
}: {
  title: string;
  priceList: IPackagePrice[];
  checkedPriceId?: string;
  description: string;
  maxDevNum: number;
  className?: string;
  onSelected: (v: string) => void;
}) => {
  const { t } = useTranslation();
  const handleSelected = useCallback(
    (p: IPackagePrice) => {
      if (p.goodsPriceId !== checkedPriceId) {
        onSelected(p.goodsPriceId);
      }
    },
    [checkedPriceId, onSelected],
  );

  return (
    <div className={`package-card ${className}`}>
      <h4>{title}</h4>
      <div className="price-list">
        {priceList
          .filter(
            (i) =>
              i.planUnit === 'month' && i.buyNum !== UNLIMITED_PACKAGE_NUMBER,
          )
          .map((p) => {
            return (
              <div
                className="price-item"
                onClick={() => handleSelected(p)}
                key={p.goodsPriceId}
              >
                <Radio checked={checkedPriceId === p.goodsPriceId} />
                <span className="price">${p.price}</span>
                <span className="unit">/{t(p.planUnit) || ''}</span>
              </div>
            );
          })}
      </div>
      <p
        className="description"
        dangerouslySetInnerHTML={{
          __html: description && description.replace(/#/gm, '<br>'),
        }}
      />
      <p className="description">{`for ${maxDevNum} ${
        +maxDevNum > 1 ? 'Devices' : 'Device'
      }`}</p>
    </div>
  );
};

export default PackageCard;
